
import React from "react";
import { connect } from "react-redux";

import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import { Icons } from "Assets/icons";
import moment from 'moment'
import Axios from "Source/axiosPool";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        conversations: store.conversations,
        document: store.document,
        project: store.project
    }
})

class AttachmentsTab extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { loggedUser, conversations, dispatch, project, isAdmin } = this.props;
        const selected = conversations.selected;
        const downloadDocument = (data) => {
            if (data.type === "document") {
                window.open(encodeURI(`/api/downloadDocument?fileName=${data.name}&origin=${data.origin}`));
            }
        }
        const deleteFile = (data) => {
            dispatch({ type: "SET_CONVERSATIONS_FILE_SELECTED", selected: data });
            $(`#deleteOnConversationModal`).modal("show");
        }
        const handleOpenFile = (doc) => {
            // window.open(window.location.origin + `/account#/projects/${project.Selected.id}/files?action=copy&file-id=${doc.id}`, '_blank');
            Axios.get(`/api/document/detail/${doc.id}`, {}).then(ret => {
                if (ret) {
                    setTimeout(() => {
                        const documentObj = ret.data;
                        dispatch({ type: "SET_DOCUMENT_SELECTED", Selected: { ...documentObj, action: "VIEW" } });
                        $(`#documentViewerModal`).modal("show");
                    }, 500)
                }
            })
        }

        if (conversations.selected.id) {
            const docs = conversations.selected.notesTagDoc.map(e=>e.document)
            const projectId = project.Selected.id
            const isMember = conversations.selected.tagged_users.filter(t=>t.linkId === loggedUser.data.id)
            const usersType = loggedUser.data.usersType
            return (
                <div class="detailsWrapper">
                    <div class={`attachmentListContainer`}>
                        {_.sortBy(docs,'dateAdded').reverse().map(file => {
                            const user = file.user
                            const isUploader = file.uploadedBy === loggedUser.data.id

                            return (
                                <div class="attachmentItem">
                                    <div class="attachmentContents">
                                        <i class="material-icons">description</i>
                                        {conversations.selected.isArchived ?
                                            <a>
                                                <p>{file.origin}</p>
                                                {user && <p>{`Uploaded by ${user.firstName} ${user.lastName} on ${moment(file.dateAdded).format('DD-MMM YYYY')}`}</p>}
                                            </a>
                                            :
                                            <a href={`${window.location.origin}/account#/projects/${projectId}/files?action=copy&file-id=${file.id}`} target="_blank" class="attachmentDetails"
                                                onClick={(e) => { e.preventDefault(); handleOpenFile(file) }}>
                                                <p>{file.origin}</p>
                                                {user && <p>{`Uploaded by ${user.firstName} ${user.lastName} on ${moment(file.dateAdded).format('DD-MMM YYYY')}`}</p>}
                                            </a>
                                        }
                                    </div>
                                    {(isMember.length > 0 && !conversations.selected.isArchived) && <div class="attachmentButtons">
                                        <a class="btnDownload"   data-tooltip-id={`file-download-${file.id}`} onClick={() => { downloadDocument(file) }}>
                                            <i class="material-icons">{Icons.DownloadIcon}</i>
                                        </a>
                                        <Tooltip id={`file-download-${file.id}`} place="bottom" effect="solid">Download</Tooltip>
                                        {((isAdmin|| isUploader || usersType === 'Internal' ) && !selected.isArchived ) &&
                                            <a class="btnDelete"   data-tooltip-id={`file-delete-${file.id}`} onClick={e => { e.preventDefault(); deleteFile(file) }}>
                                                <i class="material-icons">delete_outline</i>
                                            </a>}
                                        <Tooltip id={`file-delete-${file.id}`} place="bottom" effect="solid">Delete</Tooltip>
                                    </div>}
                            
                                    
                                </div>
                            )
                        })}

                        {docs.length === 0 && <div class="">No attachments found</div>}

                    </div>
                </div>
            );
        }

        return null;
    }
}

export default AttachmentsTab;